module.exports = __webpack_public_path__ + "img/gif.119a0451.svg";